import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const ArrowRight = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "m10 17 5-5-5-5z"  ,} )
  })
)

export default ArrowRight
